import { render, staticRenderFns } from "./PhysicalCheckCard.vue?vue&type=template&id=6531c59a&scoped=true"
import script from "./PhysicalCheckCard.vue?vue&type=script&lang=js"
export * from "./PhysicalCheckCard.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCheckCard.vue?vue&type=style&index=0&id=6531c59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531c59a",
  null
  
)

export default component.exports